import * as types from '../constants/ActionTypes';
import initialState from './initialState';
import update from 'immutability-helper';
import _ from 'lodash';

export default function(state = initialState.detalles, action) {
  switch (action.type) {
    case types.AGREGAR_DETALLE: {
      return update(state, { $push: [{ ...action.payload.detalles }] });
    }

    case types.ELIMINAR_DETALLE: {
      var col = state.map(value => Object.assign({}, value));
      // console.log("La coleccion es....: ",col);
      // console.log(_.remove(col,{_id:action.payload._id}));
      _.remove(col, { _id: action.payload._id });
      return col;
    }

    case types.SET_DETALLES: {
      return update(state, { $set: [...action.payload.detalles] });
    }

    case types.GET_DETALLES:
      return state;

    case types.REINICIAR:
      return initialState.detalles;

    default:
      return state;
  }
}
